<template>
  <div class="reset__password__conntainer">
    <h2 class="reset__title">Cambiar <br />contraseña</h2>
    <form class="pb-3 flex flex-wrap pt-4" @submit.prevent="submit">
      <div class="input-group w-full">
        <input
          ref="password"
          v-model="newPassword"
          v-validate="'required|min:6'"
          type="password"
          name="new"
          data-vv-as="contraseña"
          class="form-control"
          @focusout="changeStateInput($event)"
        />
        <label class="uppercase text-sm">nueva contraseña</label>
        <span
          v-if="errors.has('new')"
          class="pl-1 text-red mt-2 font-neue text-sm"
          >{{ errors.first("new") }}</span
        >
      </div>
      <div class="input-group w-full">
        <input
          v-model="newPasswordConfirmation"
          v-validate="'required|min:6|confirmed:password'"
          type="password"
          name="repeat"
          data-vv-as="repetir contraseña"
          class="form-control"
          @focusout="changeStateInput($event)"
        />
        <label class="uppercase text-sm">repetir nueva contraseña</label>
        <span
          v-if="errors.has('repeat')"
          class="pl-1 text-red mt-2 font-neue text-sm"
          >{{ errors.first("repeat") }}</span
        >
      </div>
      <div class="mx-auto pt-3">
        <ButtonRed class="uppercase font-neue px-6 text-xs">
          <span :class="{ spinner: loading == true }">Actualizar</span>
        </ButtonRed>
      </div>
    </form>
  </div>
</template>

<script>
import ButtonRed from "@/components/ui/ButtonRed";
import api from "@/api";
export default {
  name: "AuthPasswordChange",
  components: {
    ButtonRed,
  },
  props: ["token"],
  data() {
    return {
      loading: false,
      newPassword: "",
      newPasswordConfirmation: "",
      done: false,
    };
  },
  methods: {
    changeStateInput(e) {
      if (e.target.value.length > 0) {
        e.target.classList.add("has-value");
      } else {
        e.target.classList.remove("has-value");
      }
    },
    submit() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.loading) return;
          this.loading = true;
          var password = this.newPassword;
          var token = this.token;
          api.passwordChange({ password, token }, (err, res) => {
            this.loading = false;
            if (err) {
              this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                type: "error",
                title: "Ocurrio un error",
              });
              return;
            }
            this.done = true;
            this.newPassword = "";
            this.newPasswordConfirmation = "";
            return this.$router.push(
              this.$route.query.redirect || "/dashboard"
            );
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.reset__title {
  font-size: 55px;
  color: #fff;
  text-align: center;
  margin: 2rem 0;
  font-weight: 400;
  text-align: left;
  line-height: 1;
  @media only screen and (max-width: 992px) {
    font-size: 40px;
  }
}
.reset__password__conntainer {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: #73c9ff;
  padding: 14% 7%;
  width: 470px;
  @media only screen and (max-width: 992px) {
    width: 350px;
  }
}
.input-group {
  position: relative;
  margin: 8px auto;
}
.change__password {
  width: 470px;
  @media only screen and (max-width: 992px) {
    width: 350px;
  }
}
.form-control {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 40px;
  border: none;
  background-color: transparent;
  color: white;
  border-bottom: 1px solid #fff;

  & + label {
    position: absolute;
    top: 10px;
    left: 3px;
    font-weight: bold;
    transition: all 0.2s ease-out;
    color: white;
  }

  &:focus {
    outline: none;
    border-width: 2px;
    border-color: #0A50E6;
    transition: all 0.2s ease-out;
  }

  &:focus + label,
  &.has-value + label {
    top: -12px;
    color: #0A50E6;
    font-size: 10px;
  }
}
input {
  border-bottom: 2px solid white;
  background: #73c9ff;
  box-sizing: border-box;
  color: white;
  &:focus {
    outline: none;
    border: 2px solid #0A50E6;
  }
  box-sizing: border-box;
  width: 400px;
  height: 60px;
}
</style>
